export const computedSec = time => {
  const sed = Number(Math.ceil(time / 1000)) // 秒
  const min = Math.floor(sed / 60) // 分
  const hour = Math.floor(sed / 60 / 60) // 小时
  const day = Math.floor(sed / 60 / 60 / 24) // 天
  const secShow = sed >= 60 ? sed % 60 : sed // 显示的剩余秒
  const minShow = min >= 60 ? min % 60 : min
  const hourShow = hour >= 24 ? hour % 24 : hour
  if (day > 0) {
    return `${day}天${hourShow}小时${minShow}分${secShow}秒`
  }
  if (hour > 0) {
    return `${hourShow}小时${minShow}分${secShow}秒`
  }
  if (min > 0) {
    return `${minShow}分${secShow}秒`
  }
  if (sed >= 0) {
    return `${secShow}秒`
  }
}
const fromSingle = v => (String(v).length === 1 ? '0' + String(v) : v)
export const formTime = time => {
  const date = new Date(time)
  const year = date.getFullYear()
  const month = fromSingle(date.getMonth() + 1)
  const day = fromSingle(date.getDate())
  const hours = fromSingle(date.getHours())
  const minutes = fromSingle(date.getMinutes())
  const seconds = fromSingle(date.getSeconds())
  return {
    year,
    month,
    day,
    hours,
    minutes,
    seconds
  }
}
export const ceilMsToM = val => {
  if (typeof val !== 'number') {
    return null
  }
  return Math.ceil(Number(val) / 1000 / 60)
}
export const ceilMsToS = val => {
  if (typeof val !== 'number') {
    return null
  }
  const get = Math.ceil(Number(val) / 1000)
  return get >= 60 ? get % 60 : get
}
export const floorMsToM = val => {
  if (typeof val !== 'number') {
    return null
  }
  return Math.floor(Number(val) / 1000 / 60)
}
export class TimeLoop {
  // 封装类定时器轮询
  constructor(delayTime = null, maxTime = null) {
    this.loopCount = 0
    this.delayTime = delayTime || 3000 // 单位毫秒 25000
    this.maxTime = maxTime // 2个小时 2*60*60*1000
    this.timeLoop = null
  }

  run(loopFun, param) {
    this.timeLoop = setTimeout(() => {
      const { loopCount, delayTime, maxTime } = this
      this.loopCount++
      if (maxTime != null) {
        loopCount * delayTime < maxTime && loopFun(param)
      } else {
        loopFun(param)
      }
    }, this.delayTime)
  }

  remove() {
    this.timeLoop && clearTimeout(this.timeLoop)
  }
}
export const learningProgress = {

}

export const learningTableData = [
  {
    title: '学员',
    dataIndex: 'name',
    key: 'name',
    sorter: true,
    width: '12%',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '计划信息',
    dataIndex: 'lesson',
    key: 'lesson',
    sorter: true,
    width: '14%',
    scopedSlots: { customRender: 'lesson' },
    ellipsis: true
  },
  {
    title: '当前行为',
    dataIndex: 'currentBehavior',
    key: 'currentBehavior',
    sorter: true,
    sortDirections: ['ascend'],
    // width: '23%',
    scopedSlots: { customRender: 'learning' },
    ellipsis: true
  },
  // {
  //   title: '学习进度',
  //   dataIndex: 'learning',
  //   key: 'learning',
  //   width: 341,
  //   scopedSlots: { customRender: 'currentBehavior' }
  // },
  {
    dataIndex: 'interaction',
    key: 'interaction',
    slots: { title: 'customTitle' },
    width: 105,
    align: 'center',
    scopedSlots: { customRender: 'interaction' }
  },
  {
    title: '答题情况',
    dataIndex: 'anwser',
    key: 'anwser',
    width: 99,
    align: 'center',
    scopedSlots: { customRender: 'anwser' }
  },
  {
    title: '试题正确率',
    dataIndex: 'topic',
    key: 'topic',
    sorter: true,
    width: 107,
    scopedSlots: { customRender: 'topic' }
  },
  {
    title: '操作',
    align: 'center',
    width: 107,
    sorter: true,
    dataIndex: 'command',
    key: 'command',
    fixed: 'right',
    scopedSlots: { customRender: 'operation' }
  }
]
export const finishTableData = [
  {
    title: '学员',
    dataIndex: 'name',
    width: 198,
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '完成情况',
    dataIndex: 'finished',
    scopedSlots: { customRender: 'finished' },
    ellipsis: true
  },
  {
    title: '总学习时长',
    dataIndex: 'tatolStudyTime',
    width: 127,
    sorter: (a, b) => a.totalTime - b.totalTime,
    scopedSlots: { customRender: 'tatolStudyTime' }
  },
  {
    title: '互动正确率',
    dataIndex: 'interactionPercent',
    width: 127,
    sorter: (a, b) => a.interactionAccuracy - b.interactionAccuracy,
    scopedSlots: { customRender: 'interactionPercent' }
  },
  {
    title: '互动次数',
    dataIndex: 'interactionCount',
    width: 107,
    sorter: (a, b) => a.interactionNumber - b.interactionNumber,
    scopedSlots: { customRender: 'interactionCount' }
  },
  {
    title: '试题作答数',
    dataIndex: 'anwserCount',
    width: 127,
    sorter: (a, b) => a.answerTopicCount - b.answerTopicCount,
    scopedSlots: { customRender: 'anwserCount' }
  },
  {
    title: '试题用时',
    dataIndex: 'testUseTime',
    width: 107,
    sorter: (a, b) => a.answerTopicTime - b.answerTopicTime,
    scopedSlots: { customRender: 'testUseTime' }
  },
  {
    title: '试题正确率',
    dataIndex: 'rightPercent',
    sorter: (a, b) => a.topicAccuracy - b.topicAccuracy,
    width: 127,
    scopedSlots: { customRender: 'rightPercent' }
  },
  {
    title: '操作',
    width: 107,
    dataIndex: 'operation',
    key: 'operation',
    fixed: 'right',
    scopedSlots: { customRender: 'operation' }
  }
]
